import dateTimeToTimestamp from './dateTimeToTimestamp';
export default function parseDateTime(dateTime) {
  if (typeof dateTime === 'number' || typeof dateTime === 'string') {
    return new Date(dateTime);
  }

  return new Date(dateTimeToTimestamp(dateTime));
}